import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { OrderWithContext } from '@/models';
import { PaymentProviders } from '@/constants';

@Component({
  name: 'CmgCheckoutOrderDetails',
})
export default class CmgCheckoutOrderDetails extends Vue {
  get order(): OrderWithContext | null {
    return this.$services.order.getCurrentOrder();
  }

  get isDelivery(): boolean {
    return !this.$services.order.isPickingUp();
  }

  get tipAmount(): number {
    return this.$store.state.checkout.delivery.tip.value;
  }

  get hasCrewTipping(): boolean {
    const selectedRestaurant = this.$appStore.state.restaurant.selectedRestaurant;
    const flags = this.$appStore.state.featureFlags;
    if (!this.isDelivery) {
      return (selectedRestaurant?.crewTipPickupEnabled && flags.orderingStatus?.isCrewTippingEnabled) || false;
    }
    return false;
  }

  get isAboveStorePaymentOnline(): boolean {
    const flags = this.$appStore.state.featureFlags;
    if (flags.orderingStatus) {
      if (!flags.orderingStatus.aboveStorePaymentOnline) {
        return false;
      }

      if (this.isPayeezy && !this.isPayeezyPaymentOnline) {
        return false;
      }

      if (this.isChase && !this.isChasePaymentOnline) {
        return false;
      }
    }

    return true;
  }

  get isChasePaymentOnline(): boolean {
    const flags = this.$appStore.state.featureFlags;
    if (flags.orderingStatus && !flags.orderingStatus.isChasePaymentOnline) {
      return false;
    }

    return true;
  }

  get isPayeezyPaymentOnline(): boolean {
    const flags = this.$appStore.state.featureFlags;
    if (flags.orderingStatus && !flags.orderingStatus.isPayeezyPaymentOnline) {
      return false;
    }

    return true;
  }

  get isPayeezy(): boolean {
    return this.$appStore.state.checkout.paymentProvider == PaymentProviders.Payeezy;
  }

  get isChase(): boolean {
    return this.$appStore.state.checkout.paymentProvider == PaymentProviders.Chase;
  }

  formatPrice(price: number | undefined): string {
    return this.$services.utils.formatPrice(price);
  }

  private async setTip(tipAmount: number, isCustomTip: boolean = false) {
    if (this.order) {
      try {
        if (this.hasCrewTipping) {
          this.$services.checkout.setCrewTip(tipAmount, isCustomTip);
          await this.$services.order.updateOrderCrewTip(this.order, tipAmount);
        } else if (this.isDelivery) {
          // if their was a crew tip previously applied remove.
          await this.$services.order.updateOrderCrewTip(this.order, 0);
          this.$services.checkout.setDeliveryTip(tipAmount, isCustomTip);
          // update the current order with the delivery tip
          await this.$services.order.updateOrderTip(this.order, tipAmount);
        }
      } catch (error) {
        this.$services.logger.error('Could not update tip ' + JSON.stringify(error));
      }
    }
    this.$services.ui.setAppPepperVisibility(false);
  }

  onSelectTip(event: { tipAmount: number, isCustomTip: boolean }) {
    this.$services.ui.setAppPepperVisibility(true);
    this.$emit('on-select-tip', { isCustomTip: event.isCustomTip });
    this.setTip(event.tipAmount, event.isCustomTip);
  }
}
